export const HeadSchemaScript = ({
  json,
  schemaId,
  id,
  additionalJs = '',
}: {
  json: Record<string, any>;
  schemaId: string;
  id?: string;
  additionalJs?: string;
}) => (
  <script
    id={id}
    type='text/javascript'
    dangerouslySetInnerHTML={{
      __html: `{const ldScript=document.createElement('script');ldScript.id='${schemaId}';ldScript.type='application/ld+json';const jsonLd=${JSON.stringify(
        json
      )};{${additionalJs}}; ldScript.innerHTML=JSON.stringify(jsonLd);document.head.append(ldScript);}`,
    }}
  />
);

export default HeadSchemaScript;
